import { PerspectiveCamera, Vector3 } from 'three';
import { PointerLockControls } from 'three/examples/jsm/controls/PointerLockControls';
import { CanvasGet } from '~/Canvas';
import { Ticker } from '~/Chrono/Types';
import { Key, KeyDown } from '~/Input';

let _camera: PerspectiveCamera = null;
let _controls: PointerLockControls = null;
let _direction: Vector3 = null;
let _moveSpeed = 0.075;

/**
 * @return {void}
 */
export function CameraUpdate(ticker: Ticker): void
{
    if (KeyDown(Key.W)) {
        _controls.moveForward(_moveSpeed * ticker.ratio);
    }

    if (KeyDown(Key.S)) {
        _controls.moveForward(-_moveSpeed * ticker.ratio);
    }

    if (KeyDown(Key.A)) {
        _controls.moveRight(-_moveSpeed * ticker.ratio);
    }

    if (KeyDown(Key.D)) {
        _controls.moveRight(_moveSpeed * ticker.ratio);
    }

    _camera.getWorldDirection(_direction);
}

/**
 * @return {PerspectiveCamera}
 */
export function CameraGet(): PerspectiveCamera
{
    return _camera;
}

/**
 * @return {Vector3}
 */
export function CameraGetDirection(): Vector3
{
    return _direction;
}

/**
 * @return {[PerspectiveCamera, PointerLockControls]}
 */
export function CameraInit(canvas?: HTMLCanvasElement): [PerspectiveCamera, PointerLockControls]
{
    canvas = canvas ?? CanvasGet();

    _camera = new PerspectiveCamera(75, canvas.clientWidth / canvas.clientHeight, 0.1, 512);
    _controls = new PointerLockControls(_camera, canvas);
    _direction = new Vector3;

    _camera.position.set(0, 1.5, 0);
    _camera.getWorldDirection(_direction);

    canvas.addEventListener('click', (): void => {
        _controls.lock();
    });

    return [_camera, _controls];
}
